import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import { addAlertToStore, findAlertInStore, removeAlertFromStore } from '../../utils/AlertUtils';
import { convertHoursToSeconds, getDateTimeInSeconds } from '../../utils/DateUtils';
import CancelIcon from 'components/icons/Cancel';

class PageAlertBanner extends Component {
  static propTypes = {
    FRN_componentInstanceId: PropTypes.string,
    backgroundColor: PropTypes.string,
    text: PropTypes.string,
    textAlign: PropTypes.string,
    textColor: PropTypes.string,
    destinationUri: PropTypes.string,
    dismissOptions: PropTypes.shape({
      isDismissable: PropTypes.bool,
      dismissTimeInHours: PropTypes.number
    })
  }

  static defaultProps = {
    backgroundColor: '#FFFF00',
    text: '',
    textColor: '#FFFFFF',
    destinationUri: '',
    dismissOptions: {
      isDismissable: false,
      dismissTimeInHours: 24
    }
  }

  state = {
    showAlert: true
  }

  componentWillMount() {
    const { FRN_componentInstanceId, dismissOptions: { isDismissable } } = this.props;

    if (isDismissable) {
      const alertInStore = findAlertInStore(FRN_componentInstanceId);

      if (alertInStore) {
        const { timeout, data } = alertInStore;

        const time = getDateTimeInSeconds();
        const showAlert = time > timeout || this.props.text !== data;

        if (showAlert) {
          removeAlertFromStore(FRN_componentInstanceId);
        } else {
          this._startAutoShowAlertInterval(timeout - time);
        }

        this.setState({ showAlert });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this._showAlertAgainInterval);
  }

  _dismissAlert() {
    const { FRN_componentInstanceId, text, dismissOptions: { dismissTimeInHours } } = this.props;
    const timeout = convertHoursToSeconds(dismissTimeInHours);

    addAlertToStore(FRN_componentInstanceId, getDateTimeInSeconds() + timeout, text);
    this._startAutoShowAlertInterval(timeout);

    this.setState({
      showAlert: false
    });
  }

  _startAutoShowAlertInterval(timeout) {
    this._showAlertAgainInterval = setInterval(() => {
      removeAlertFromStore(this.props.FRN_componentInstanceId);
      clearInterval(this._showAlertAgainInterval);

      this.setState({
        showAlert: true
      });
    }, timeout);
  }

  render() {
    if (!this.state.showAlert) {
      return null;
    }

    const {
      backgroundColor,
      text,
      textAlign,
      textColor,
      destinationUri,
      dismissOptions: { isDismissable }
    } = this.props;

    const className = classNames('PageAlertBanner-text', {'PageAlertBanner--link': destinationUri});
    const bannerStyle = {backgroundColor, color: textColor, textAlign};

    const pageAlertBanner = destinationUri ?
      <a className={className} style={bannerStyle} href={destinationUri}>{text}</a> :
      <div className={className} style={bannerStyle}>{text}</div>;

    return (
      <div className="PageAlertBanner">
        { isDismissable && <div className="PageAlertBanner-dismissBtn" onClick={() => this._dismissAlert()}><CancelIcon color={textColor} /></div> }
        {pageAlertBanner}
      </div>
    );
  }
}

export default PageAlertBanner;



// WEBPACK FOOTER //
// ./app/components/shared/PageAlertBanner.js